var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGafiLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 466,
    height: 312,
    viewBox: "0 0 466 312",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 466,
    height: 312,
    rx: 12,
    fill: "url(#paint0_linear_1057_1123)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1057_1123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.117 241.357V234.911H93.0779V233.59H100.637V234.911H97.5197V241.357H96.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.676 241.357V233.59H105.156V241.357H103.676ZM104.299 238.25V236.93H110.923V238.25H104.299ZM110.3 241.357V233.59H111.702V241.357H110.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.677 241.357V233.59H122.378V234.911H117.157V240.037H122.456V241.357H115.677ZM116.456 238.017V236.697H121.755V238.017H116.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.652 241.357V233.59H133.054L139.133 239.648L138.977 239.726C138.977 239.493 138.899 239.26 138.899 238.949C138.899 238.716 138.821 238.406 138.821 238.173C138.821 237.94 138.821 237.629 138.821 237.396C138.821 237.163 138.821 236.852 138.821 236.619C138.821 236.386 138.821 236.153 138.821 235.92V233.59H140.224V241.357H138.821L132.743 235.377L132.898 235.299C132.898 235.454 132.898 235.61 132.976 235.765C133.054 235.92 132.976 236.153 133.054 236.309C133.054 236.542 133.132 236.697 133.132 236.93C133.132 237.163 133.132 237.396 133.21 237.629C133.21 237.862 133.21 238.095 133.21 238.328V241.357H131.652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.198 241.357V233.59H150.899V234.911H145.678V240.037H150.977V241.357H144.198ZM144.977 238.017V236.697H150.276V238.017H144.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.744 241.357V234.911H153.705V233.59H161.264V234.911H158.225V241.357H156.744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.251 241.357L163.446 233.59H165.004L166.563 237.862C166.641 238.017 166.641 238.173 166.718 238.406C166.796 238.561 166.874 238.794 166.874 239.027C166.952 239.26 166.952 239.415 167.03 239.571C167.108 239.726 167.108 239.959 167.186 240.037H166.718C166.796 239.804 166.874 239.648 166.952 239.338C167.03 239.105 167.108 238.872 167.264 238.561C167.342 238.328 167.498 238.017 167.576 237.784L168.9 234.755H170.225L171.55 237.784C171.628 238.017 171.784 238.25 171.862 238.561C171.94 238.794 172.095 239.027 172.173 239.338C172.251 239.571 172.329 239.804 172.329 239.959L171.94 240.037C171.94 239.881 172.017 239.804 172.017 239.648C172.095 239.493 172.095 239.338 172.173 239.182C172.251 239.027 172.251 238.872 172.329 238.716C172.407 238.561 172.407 238.406 172.485 238.25C172.563 238.095 172.563 237.94 172.641 237.862L174.355 233.668H175.836L172.641 241.435H171.628L169.446 236.309L169.68 236.386L167.498 241.435H166.251V241.357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.849 241.512C182.148 241.512 181.525 241.435 180.901 241.202C180.356 240.969 179.81 240.736 179.343 240.347C178.875 239.959 178.563 239.571 178.33 239.105C178.096 238.639 177.94 238.095 177.94 237.551C177.94 237.008 178.096 236.464 178.33 235.998C178.563 235.532 178.875 235.066 179.343 234.755C179.81 234.367 180.278 234.134 180.901 233.901C181.525 233.668 182.148 233.59 182.849 233.59C183.551 233.59 184.174 233.668 184.797 233.901C185.421 234.134 185.888 234.367 186.278 234.755C186.668 235.144 187.057 235.532 187.291 235.998C187.525 236.464 187.681 237.008 187.681 237.551C187.681 238.095 187.525 238.639 187.291 239.105C187.057 239.571 186.746 240.037 186.278 240.347C185.888 240.736 185.343 240.969 184.797 241.202C184.174 241.357 183.551 241.512 182.849 241.512ZM182.849 240.114C183.317 240.114 183.784 240.037 184.174 239.881C184.564 239.726 184.953 239.571 185.187 239.338C185.421 239.105 185.733 238.794 185.888 238.483C186.044 238.173 186.122 237.784 186.122 237.474C186.122 237.085 186.044 236.775 185.888 236.464C185.733 236.153 185.499 235.843 185.187 235.61C184.875 235.377 184.564 235.144 184.174 235.066C183.784 234.911 183.317 234.833 182.849 234.833C182.382 234.833 181.914 234.911 181.525 235.066C181.135 235.221 180.745 235.377 180.434 235.61C180.122 235.843 179.888 236.153 179.732 236.464C179.576 236.775 179.498 237.163 179.498 237.474C179.498 237.862 179.576 238.173 179.732 238.483C179.888 238.794 180.122 239.105 180.434 239.338C180.745 239.571 181.057 239.804 181.525 239.881C181.914 240.037 182.382 240.114 182.849 240.114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.031 241.357V233.59H195.551C196.097 233.59 196.564 233.668 196.954 233.901C197.344 234.134 197.655 234.367 197.889 234.755C198.123 235.144 198.279 235.532 198.279 235.998C198.279 236.464 198.123 236.93 197.889 237.318C197.655 237.707 197.266 238.017 196.876 238.25C196.486 238.483 195.941 238.561 195.473 238.561H192.512V241.357H191.031ZM192.434 237.318H195.24C195.473 237.318 195.707 237.241 195.941 237.163C196.175 237.085 196.33 236.93 196.486 236.697C196.642 236.542 196.72 236.309 196.72 236.076C196.72 235.843 196.642 235.687 196.486 235.454C196.33 235.299 196.175 235.144 195.941 235.066C195.707 234.988 195.473 234.911 195.24 234.911H192.434V237.318ZM196.954 241.357L194.304 237.862L195.863 237.551L198.746 241.357H196.954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.331 241.357V233.59H203.811V241.357H202.331ZM203.344 239.493L203.188 238.017L208.877 233.59H210.903L203.344 239.493ZM208.877 241.357L205.526 237.241L206.383 236.153L210.747 241.357H208.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.072 241.512C223.371 241.512 222.748 241.435 222.124 241.202C221.579 240.969 221.033 240.736 220.566 240.347C220.098 239.959 219.786 239.571 219.553 239.105C219.319 238.639 219.163 238.095 219.163 237.551C219.163 237.008 219.319 236.464 219.553 235.998C219.786 235.532 220.098 235.066 220.566 234.755C221.033 234.367 221.501 234.134 222.124 233.901C222.748 233.668 223.371 233.59 224.072 233.59C224.774 233.59 225.397 233.668 226.021 233.901C226.644 234.134 227.112 234.367 227.501 234.755C227.891 235.144 228.28 235.532 228.514 235.998C228.748 236.464 228.904 237.008 228.904 237.551C228.904 238.095 228.748 238.639 228.514 239.105C228.28 239.571 227.969 240.037 227.501 240.347C227.112 240.736 226.566 240.969 226.021 241.202C225.397 241.357 224.774 241.512 224.072 241.512ZM224.072 240.114C224.54 240.114 225.008 240.037 225.397 239.881C225.787 239.726 226.176 239.571 226.41 239.338C226.644 239.105 226.956 238.794 227.112 238.483C227.267 238.173 227.345 237.784 227.345 237.474C227.345 237.085 227.267 236.775 227.112 236.464C226.956 236.153 226.722 235.843 226.41 235.61C226.099 235.377 225.787 235.144 225.397 235.066C225.008 234.911 224.54 234.833 224.072 234.833C223.605 234.833 223.137 234.911 222.748 235.066C222.358 235.221 221.968 235.377 221.657 235.61C221.345 235.843 221.111 236.153 220.955 236.464C220.8 236.775 220.722 237.163 220.722 237.474C220.722 237.862 220.8 238.173 220.955 238.483C221.111 238.794 221.345 239.105 221.657 239.338C221.968 239.571 222.28 239.804 222.748 239.881C223.137 240.037 223.605 240.114 224.072 240.114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.255 241.357V233.59H233.735V241.357H232.255ZM232.8 238.328V237.008H238.333V238.328H232.8ZM232.956 234.911V233.59H238.8V234.911H232.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.97 241.512C251.347 241.512 250.723 241.435 250.178 241.279C249.632 241.124 249.087 240.891 248.697 240.503C248.23 240.192 247.918 239.726 247.684 239.26C247.45 238.794 247.294 238.173 247.294 237.474C247.294 236.93 247.45 236.386 247.684 235.92C247.918 235.454 248.307 234.988 248.697 234.678C249.165 234.289 249.632 234.056 250.256 233.823C250.879 233.59 251.502 233.513 252.204 233.513C252.749 233.513 253.295 233.59 253.762 233.668C254.23 233.823 254.697 233.979 255.009 234.134C255.399 234.367 255.633 234.522 255.866 234.755L254.931 235.765C254.697 235.61 254.386 235.377 254.074 235.221C253.762 235.066 253.451 234.988 253.139 234.833C252.827 234.755 252.438 234.678 252.048 234.678C251.58 234.678 251.113 234.755 250.723 234.911C250.334 235.066 249.944 235.221 249.632 235.454C249.321 235.687 249.087 235.998 248.931 236.309C248.775 236.619 248.697 237.008 248.697 237.318C248.697 237.784 248.775 238.173 248.931 238.561C249.087 238.872 249.321 239.182 249.632 239.415C249.944 239.648 250.256 239.804 250.723 239.881C251.113 239.959 251.502 240.037 251.97 240.037C252.438 240.037 252.827 239.959 253.217 239.881C253.606 239.804 253.918 239.648 254.23 239.571C254.542 239.415 254.697 239.26 254.853 239.027C255.009 238.794 255.087 238.561 255.087 238.328V238.173L255.321 238.483H252.048V237.241H256.568C256.568 237.318 256.568 237.474 256.568 237.551C256.568 237.629 256.568 237.707 256.568 237.784C256.568 237.862 256.568 237.862 256.568 237.94C256.568 238.561 256.49 239.027 256.256 239.493C256.022 239.959 255.71 240.27 255.321 240.58C254.931 240.891 254.386 241.046 253.84 241.202C253.295 241.435 252.671 241.512 251.97 241.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.828 241.357L262.646 233.59H264.205L268.023 241.357H266.464L263.971 236.309C263.893 236.153 263.815 235.998 263.737 235.843C263.659 235.687 263.581 235.532 263.581 235.454C263.503 235.299 263.425 235.144 263.425 235.066C263.347 234.911 263.347 234.755 263.269 234.6H263.659C263.581 234.755 263.503 234.911 263.503 235.066C263.425 235.221 263.347 235.377 263.347 235.532C263.347 235.687 263.192 235.843 263.114 235.92C263.036 236.076 262.958 236.231 262.88 236.386L260.386 241.435H258.828V241.357ZM260.542 239.726L261.088 238.483H265.685L265.919 239.726H260.542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.906 241.357V233.59H272.309L275.894 237.94H275.27L278.855 233.59H280.257V241.357H278.855V238.328C278.855 237.707 278.855 237.163 278.933 236.619C278.933 236.076 279.011 235.532 279.089 234.988L279.244 235.532L276.049 239.338H275.348L272.153 235.532L272.309 234.988C272.387 235.532 272.465 236.076 272.465 236.619C272.465 237.163 272.543 237.707 272.543 238.328V241.357H270.906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.076 241.357V233.59H290.777V234.911H285.478V240.037H290.777V241.357H284.076ZM284.855 238.017V236.697H290.154V238.017H284.855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.051 241.357V233.59H301.531V241.357H300.051ZM300.518 238.328V237.008H306.051V238.328H300.518ZM300.674 234.911V233.59H306.519V234.911H300.674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.181 241.357V240.037H312.207V234.988H310.181V233.668H315.792V234.988H313.766V240.037H315.792V241.357H310.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.922 241.357V233.59H321.325L327.403 239.648L327.247 239.726C327.247 239.493 327.169 239.26 327.169 238.949C327.169 238.716 327.091 238.406 327.091 238.173C327.091 237.94 327.091 237.629 327.091 237.396C327.091 237.163 327.091 236.852 327.091 236.619C327.091 236.386 327.091 236.153 327.091 235.92V233.59H328.494V241.357H327.091L321.013 235.377L321.169 235.299C321.169 235.454 321.169 235.61 321.247 235.765C321.325 235.92 321.247 236.153 321.325 236.309C321.325 236.542 321.402 236.697 321.402 236.93C321.402 237.163 321.402 237.396 321.48 237.629C321.48 237.862 321.48 238.095 321.48 238.328V241.357H319.922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.377 241.357L335.196 233.59H336.754L340.573 241.357H339.014L336.52 236.309C336.442 236.153 336.365 235.998 336.287 235.843C336.209 235.687 336.131 235.532 336.131 235.454C336.053 235.299 335.975 235.144 335.975 235.066C335.897 234.911 335.897 234.755 335.819 234.6H336.209C336.131 234.755 336.053 234.911 336.053 235.066C335.975 235.221 335.897 235.377 335.897 235.532C335.897 235.687 335.741 235.843 335.663 235.92C335.585 236.076 335.507 236.231 335.429 236.386L332.936 241.435H331.377V241.357ZM333.092 239.726L333.637 238.483H338.235L338.469 239.726H333.092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.456 241.357V233.59H344.859L350.937 239.648L350.781 239.726C350.781 239.493 350.703 239.26 350.703 238.949C350.703 238.716 350.625 238.406 350.625 238.173C350.625 237.94 350.625 237.629 350.625 237.396C350.625 237.163 350.625 236.852 350.625 236.619C350.625 236.386 350.625 236.153 350.625 235.92V233.59H352.028V241.357H350.625L344.547 235.377L344.703 235.299C344.703 235.454 344.703 235.61 344.781 235.765C344.858 235.92 344.781 236.153 344.859 236.309C344.859 236.542 344.936 236.697 344.936 236.93C344.936 237.163 344.936 237.396 345.014 237.629C345.014 237.862 345.014 238.095 345.014 238.328V241.357H343.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.054 241.512C359.431 241.512 358.807 241.435 358.262 241.202C357.716 241.046 357.249 240.736 356.781 240.347C356.391 239.959 356.002 239.571 355.768 239.105C355.534 238.639 355.378 238.095 355.378 237.474C355.378 236.93 355.534 236.386 355.768 235.843C356.002 235.299 356.314 234.911 356.781 234.6C357.171 234.212 357.716 233.979 358.262 233.746C358.807 233.513 359.431 233.435 360.054 233.435C360.522 233.435 361.067 233.513 361.535 233.59C362.002 233.746 362.392 233.901 362.781 234.056C363.171 234.212 363.483 234.445 363.717 234.678L362.859 235.843C362.626 235.61 362.314 235.454 362.08 235.299C361.768 235.144 361.457 234.988 361.145 234.911C360.833 234.833 360.444 234.755 359.976 234.755C359.586 234.755 359.197 234.833 358.885 234.911C358.495 235.066 358.184 235.221 357.95 235.454C357.638 235.687 357.405 235.92 357.249 236.309C357.093 236.697 357.015 237.008 357.015 237.396C357.015 237.862 357.093 238.25 357.249 238.561C357.405 238.872 357.638 239.182 357.95 239.415C358.262 239.648 358.573 239.804 358.963 239.959C359.353 240.037 359.742 240.114 360.132 240.114C360.599 240.114 360.989 240.037 361.301 239.959C361.613 239.881 361.924 239.726 362.236 239.571C362.47 239.415 362.703 239.26 362.937 239.105L363.639 240.27C363.405 240.425 363.171 240.658 362.781 240.813C362.392 241.046 362.002 241.202 361.535 241.357C361.067 241.512 360.599 241.512 360.054 241.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.99 241.357V233.59H373.691V234.911H368.47V240.037H373.769V241.357H366.99ZM367.769 238.017V236.697H373.068V238.017H367.769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.028 203.611H132.587L141.314 223.571H135.392L133.6 219.3H124.171L122.378 223.571H116.378L125.028 203.611ZM131.963 215.727L128.846 208.582L125.729 215.727H131.963Z",
    fill: "url(#paint1_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.665 203.611H163.835V207.261H150.744V211.688H162.277V215.339H150.744V223.649H144.665V203.611Z",
    fill: "url(#paint2_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.108 203.611H173.186V223.571H167.108V203.611Z",
    fill: "url(#paint3_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.598 211.222V214.873H107.572V219.999H100.169C99.4679 219.999 99.0783 219.688 99.0783 219.144V208.116C99.0783 207.572 99.4679 207.261 100.169 207.261H112.482V203.611H98.1432H96.8184C95.3378 205.087 94.4806 205.941 93 207.417V207.727V219.455V223.571H98.1432H109.832C111.313 222.096 112.17 221.241 113.651 219.766V211.222H103.598Z",
    fill: "url(#paint4_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.226 203.611H194.772L203.422 215.572V203.611H209.5V223.571H202.954L194.305 211.611V223.571H188.226V203.611Z",
    fill: "url(#paint5_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 203.611H233.736V207.261H220.332V211.378H232.177V215.028H220.332V219.999H233.736V223.649H214.254V203.611Z",
    fill: "url(#paint6_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.93 203.611H259.451V207.261H251.191V223.649H245.113V207.261H236.93V203.611Z",
    fill: "url(#paint7_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.413 203.611L272.387 217.669L277.062 203.611H283.452L288.128 217.669L292.102 203.611H298.025L292.414 223.571H284.699L280.257 210.368L275.816 223.571H268.101L262.49 203.611H268.413Z",
    fill: "url(#paint8_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.716 203.533H357.794V211.222L365.821 203.533H373.302L364.73 211.766L373.613 223.494H366.834L360.756 215.494L357.794 218.368V223.494H351.716V203.533Z",
    fill: "url(#paint9_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.351 203.611H306.753H305.35C303.869 205.087 303.012 205.941 301.531 207.417V207.727V219.455V223.571H306.675H317.273H318.675C320.156 222.096 321.013 221.241 322.494 219.766V219.455V207.727V203.611H317.351ZM316.415 219.144C316.415 219.688 316.026 219.999 315.324 219.999H308.623C307.921 219.999 307.532 219.688 307.532 219.144V208.116C307.532 207.572 307.921 207.261 308.623 207.261H315.324C316.026 207.261 316.415 207.494 316.415 208.116V219.144Z",
    fill: "url(#paint10_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.144 216.038H347.274V211.921V207.727V203.611H342.131H331.066C329.585 205.087 328.728 205.941 327.247 207.417V223.649H333.326V216.115H336.598L341.586 223.649H348.132L343.144 216.038ZM341.196 211.533C341.196 212.077 340.807 212.387 340.105 212.387H333.248V207.261H340.105C340.807 207.261 341.196 207.494 341.196 208.116V211.533Z",
    fill: "url(#paint11_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1057_1123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.667 125.996L204.933 167.327H181.958L173 151.486L225.667 64V125.996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.721 149.758L250.736 177.552L246.98 183.6H219.02L215.336 177.552L229.279 149.758H236.721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 151.486L284.042 167.327H261.068L240.333 125.996V64L293 151.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.721 149.758L234.987 157.678H231.013L229.279 149.758H236.721Z",
    fill: "url(#paint12_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.013 157.678L223.572 172.439C224.439 173.807 224.728 174.239 225.595 175.679H240.405C241.272 174.311 241.561 173.879 242.428 172.439L234.987 157.678C233.181 157.678 232.819 157.678 231.013 157.678Z",
    fill: "url(#paint13_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.595 175.679L219.02 183.6L215.336 177.552L223.572 172.439L225.595 175.679Z",
    fill: "url(#paint14_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.98 183.6H219.021L225.595 175.679H240.405L246.98 183.6Z",
    fill: "url(#paint15_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.736 177.552L246.98 183.6L240.405 175.679L242.428 172.439L250.736 177.552Z",
    fill: "url(#paint16_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.736 177.552L242.428 172.439L234.987 157.678L236.721 149.758L250.736 177.552Z",
    fill: "url(#paint17_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.013 157.678L223.572 172.439L215.336 177.552L229.279 149.758L231.013 157.678Z",
    fill: "url(#paint18_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.923 89.3V125.374L261.988 149.424H275.354C277.665 145.32 278.243 144.312 280.555 140.207L249.923 89.3Z",
    fill: "url(#paint19_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.042 167.327H261.068L262.151 149.47H275.517L276.528 151.486L284.042 167.327Z",
    fill: "url(#paint20_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 151.486L284.042 167.327L276.528 151.486L275.517 149.47L277.034 146.877L277.323 146.301L278.117 144.861L278.406 144.357L278.695 143.853L279.273 142.845L279.562 142.341L280.791 140.253L293 151.486Z",
    fill: "url(#paint21_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 151.486L280.791 140.253L250.158 89.3457L240.333 64L293 151.486Z",
    fill: "url(#paint22_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.158 89.3457V125.42L240.333 125.996V64L250.158 89.3457Z",
    fill: "url(#paint23_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.151 149.47L261.068 167.327L240.333 125.996L250.158 125.42L262.151 149.47Z",
    fill: "url(#paint24_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.79 140.253L276.528 151.486L262.151 149.47H275.517L280.79 140.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.914 89.3457V125.42L203.849 149.47H190.483C188.171 145.365 187.594 144.357 185.282 140.253L215.914 89.3457Z",
    fill: "url(#paint25_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.958 167.327H204.932L203.849 149.47H190.483L189.472 151.486L181.958 167.327Z",
    fill: "url(#paint26_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 151.486L181.958 167.327L189.472 151.486L190.483 149.47L188.966 146.877L188.677 146.301L187.883 144.861L187.594 144.357L187.305 143.853L186.727 142.845L186.438 142.341L185.209 140.253L173 151.486Z",
    fill: "url(#paint27_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 151.486L185.209 140.253L215.842 89.3457L225.667 64L173 151.486Z",
    fill: "url(#paint28_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.842 89.3457V125.42L225.667 125.996V64L215.842 89.3457Z",
    fill: "url(#paint29_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.849 149.47L204.932 167.327L225.667 125.996L215.842 125.42L203.849 149.47Z",
    fill: "url(#paint30_linear_1057_1123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.282 140.253L189.472 151.486L203.849 149.47H190.483L185.282 140.253Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1057_1123",
    x1: 233,
    y1: 0,
    x2: 233,
    y2: 312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010318"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1057_1123",
    x1: 128.846,
    y1: 203.611,
    x2: 128.846,
    y2: 223.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1057_1123",
    x1: 154.25,
    y1: 203.611,
    x2: 154.25,
    y2: 223.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1057_1123",
    x1: 170.147,
    y1: 203.611,
    x2: 170.147,
    y2: 223.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1057_1123",
    x1: 103.325,
    y1: 203.611,
    x2: 103.325,
    y2: 223.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1057_1123",
    x1: 198.863,
    y1: 203.611,
    x2: 198.863,
    y2: 223.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1057_1123",
    x1: 223.995,
    y1: 203.611,
    x2: 223.995,
    y2: 223.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1057_1123",
    x1: 248.191,
    y1: 203.611,
    x2: 248.191,
    y2: 223.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1057_1123",
    x1: 280.257,
    y1: 203.611,
    x2: 280.257,
    y2: 223.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1057_1123",
    x1: 362.665,
    y1: 203.533,
    x2: 362.665,
    y2: 223.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1057_1123",
    x1: 312.013,
    y1: 203.611,
    x2: 312.013,
    y2: 223.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1057_1123",
    x1: 337.689,
    y1: 203.611,
    x2: 337.689,
    y2: 223.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1057_1123",
    x1: 233.007,
    y1: 157.994,
    x2: 233.007,
    y2: 149.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#DBEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1057_1123",
    x1: 241.213,
    y1: 171.979,
    x2: 229.107,
    y2: 166.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8143,
    stopColor: "#DBF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1057_1123",
    x1: 216.851,
    y1: 180.849,
    x2: 224.324,
    y2: 174.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5066,
    stopColor: "#4E97EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75B7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1057_1123",
    x1: 223.634,
    y1: 187.425,
    x2: 240.615,
    y2: 176.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1057_1123",
    x1: 242.618,
    y1: 175.458,
    x2: 249.925,
    y2: 181.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6538,
    stopColor: "#AEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1057_1123",
    x1: 239.83,
    y1: 166.063,
    x2: 242.995,
    y2: 164.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8143,
    stopColor: "#DBF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1057_1123",
    x1: 222.173,
    y1: 163.617,
    x2: 226.956,
    y2: 165.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75B7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1057_1123",
    x1: 270.565,
    y1: 146.885,
    x2: 252.037,
    y2: 97.1835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8143,
    stopColor: "#F6FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1057_1123",
    x1: 259.849,
    y1: 158.373,
    x2: 275.885,
    y2: 158.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3542,
    stopColor: "#4E96E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1057_1123",
    x1: 278.769,
    y1: 155.925,
    x2: 289.442,
    y2: 149.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6538,
    stopColor: "#AEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1057_1123",
    x1: 263.018,
    y1: 110.003,
    x2: 267.382,
    y2: 107.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8143,
    stopColor: "#DBF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1057_1123",
    x1: 238.504,
    y1: 95.0545,
    x2: 248.288,
    y2: 94.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4172,
    stopColor: "#99CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1057_1123",
    x1: 250.894,
    y1: 146.525,
    x2: 257.814,
    y2: 142.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3542,
    stopColor: "#4E96E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1057_1123",
    x1: 195.272,
    y1: 146.93,
    x2: 213.8,
    y2: 97.2292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8143,
    stopColor: "#F6FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1057_1123",
    x1: 206.151,
    y1: 158.373,
    x2: 190.115,
    y2: 158.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3542,
    stopColor: "#4E96E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1057_1123",
    x1: 187.231,
    y1: 155.925,
    x2: 176.558,
    y2: 149.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6538,
    stopColor: "#AEDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1057_1123",
    x1: 202.982,
    y1: 110.003,
    x2: 198.618,
    y2: 107.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8143,
    stopColor: "#DBF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1057_1123",
    x1: 227.496,
    y1: 95.0545,
    x2: 217.712,
    y2: 94.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4172,
    stopColor: "#99CCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1057_1123",
    x1: 215.106,
    y1: 146.525,
    x2: 208.186,
    y2: 142.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A7AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3542,
    stopColor: "#4E96E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99CFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1057_1123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 184,
    fill: "white",
    transform: "translate(93 64)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1057_1123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 119.6,
    fill: "white",
    transform: "translate(173 64)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGafiLg);
export default __webpack_public_path__ + "static/media/gafi-lg.3da6fea70406fc650768c9505bac92c7.svg";
export { ForwardRef as ReactComponent };